import { useCheckClosePair } from '@/hooks/useCheckClosePair';
import clsx from 'clsx';
import { useCallback } from 'react';
import { useFormContext, useWatch } from 'react-hook-form';
import { FormValue, Type } from './type';

type Props = {
    goDetail: () => void;
};

export function BuySell({ goDetail }: Props) {
    const { control, setValue } = useFormContext<FormValue>();

    const pairIndex = useWatch({ control, name: 'pairIndex' });

    const { isClose } = useCheckClosePair(Number(pairIndex));

    const disabled = isClose;

    const handleGoDetail = useCallback(
        (type: Type) => {
            setValue('type', type);
            goDetail();
        },
        [goDetail, setValue]
    );

    return (
        <div
            className={clsx(
                'grid grid-cols-2 gap-2 items-end z-[2]',
                'fixed bottom-[6.75rem] right-4 left-4 bg-black z-[999]'
            )}
        >
            <button
                disabled={disabled}
                onClick={() => handleGoDetail(Type.Long)}
                data-action="submit-long"
                data-category="long-short"
                className={clsx(
                    'long h-[52px] bg-[#50EE4D] rounded-[10px] mb-1 transition-all',
                    {
                        'opacity-50': disabled,
                    }
                )}
            >
                <span className="long-short">Long</span>
            </button>

            <button
                disabled={disabled}
                onClick={() => handleGoDetail(Type.Short)}
                data-action="submit-short"
                data-category="long-short"
                className={clsx(
                    'short h-[52px] bg-[#FF695F] rounded-[10px] mb-1 transition-all',
                    {
                        'opacity-50': disabled,
                    }
                )}
            >
                <span className="long-short">Short</span>
            </button>
        </div>
    );
}
